import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// TypeScript에서 window.gtag를 인식하도록 선언합니다.
declare global {
  interface Window {
    gtag: (
      command: string,
      targetId: string,
      config?: {
        page_path?: string;
        page_title?: string;
      }
    ) => void;
  }
}

// .env 파일에서 REACT_APP_GA_MEASUREMENT_ID 값으로 ID를 가져옵니다.
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const useGAPageView = () => {
  const location = useLocation();

  useEffect(() => {
    if (!GA_MEASUREMENT_ID) {
      console.warn("GA Measurement ID has not been set up in the environment variables.");
      return;
    }

    if (window.gtag) {
        window.gtag('config', GA_MEASUREMENT_ID, {
            page_path: location.pathname + location.search,
            page_title: document.title,
        });
    }
  }, [location]);
};

